import {
  Input,
  danger,
  Button,
  Header,
  success,
  useState,
  useEffect,
  ErrorAlert,
  getProjects,
  getCategories,
  useCustomForm,
  SmsBalanceAlert,
  getAllGiftProject,
} from "@";
import {
  projectsAmountsOptions,
  messageDonateTypeOptions,
} from "./utils/options";
import { sendMultiSMS } from "./utils/api";
import { multiSendDefaultValues, multiSendSchema } from "./utils/validation";

const Multiple = () => {
  // stats and variables
  const [error, setError] = useState(false);
  const [projects, setProjects] = useState([]);
  const [categories, setCategories] = useState([]);
  const [giftProjects, setGiftProjects] = useState([]);
  const [isSmsBalanceLow, setIsSmsBalanceLow] = useState(true);
  const links = [
    { name: "المراسلات", link: "/messages" },
    { name: " إرسال رسالة", link: "" },
  ];

  // Use form
  const {
    reset,
    watch,
    errors,
    register,
    setValue,
    handleSubmit,
    isSubmitting,
  } = useCustomForm(multiSendDefaultValues, multiSendSchema);

  const getSmsBalance = (value) => setIsSmsBalanceLow(value);

  // get data from api
  const fetchData = async () => {
    if (isSmsBalanceLow) return;
    try {
      const [categoriesRes, projectsRes, giftProjectsRes] = await Promise.all([
        getCategories(),
        getProjects(1, null, null),
        getAllGiftProject(),
      ]);

      setCategories(categoriesRes.data);
      setProjects(projectsRes.data.data);
      setGiftProjects(giftProjectsRes.data);
      setError(false);
    } catch (error) {
      setError(true);
    }
  };

  // send message
  const submit = async (data) => {
    try {
      await sendMultiSMS(data);
      success("تم الارسال");
      reset();
    } catch (error) {
      danger("حدث خطأ أثناء الإرسال");
    }
  };

  // get data on page load
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {/* error alert */}
      <ErrorAlert reload={fetchData} show={error} />
      <SmsBalanceAlert isShow={getSmsBalance} />

      {/* header */}
      <Header title=" إرسال رسالة" links={links} />

      <form onSubmit={handleSubmit(submit)} className="relative">
        <div className="card relative grid gap-5 p-4 lg:grid-cols-2">
          {/* message type */}
          <Input
            star={!isSmsBalanceLow}
            noEmptyOption
            type="select"
            label="نوع الرسالة"
            error={errors.messageType}
            disabled={isSmsBalanceLow}
            input={register("messageType")}
            list={[
              { value: 0, name: "رسالة جماعية عامة" },
              { value: 1, name: "رسالة جماعية مخصصة" },
            ]}
          />

          {/* category */}
          <Input
            noEmptyOption
            type="select"
            label="نوع التبرع"
            error={errors.category}
            disabled={isSmsBalanceLow}
            input={register("category")}
            list={messageDonateTypeOptions}
          />
        </div>

        {watch("messageType") === "1" && (
          <div className="card grid justify-start gap-5 p-4 md:grid-cols-3 lg:col-span-2">
            <div>
              <Input
                star
                type="select"
                noEmptyOption
                label="المبلغ"
                disabled={isSmsBalanceLow}
                list={projectsAmountsOptions}
                input={register("projectAmount")}
              />
            </div>
            <div>
              <Input
                disabled={isSmsBalanceLow}
                star
                label="حالة التبرع"
                type="select"
                list={[
                  { value: true, name: "مدفوعة" },
                  { value: false, name: "غير مدفوعة" },
                ]}
                input={register("isPaid")}
              />
            </div>

            <Input
              star
              style="mb-5"
              type="date-range"
              labelA="التاريخ من"
              labelB="التاريخ الى"
              errorB={errors.toDate}
              valueB={watch("toDate")}
              errorA={errors.fromDate}
              disabled={isSmsBalanceLow}
              valueA={watch("fromDate")}
              inputB={register("toDate")}
              inputA={register("fromDate")}
              changeB={(e) => setValue("toDate", e)}
              changeA={(e) => setValue("fromDate", e)}
            />

            <div>
              <Input
                star
                type="select"
                list={projects}
                label="المشروعات"
                disabled={isSmsBalanceLow}
                input={register("projectId")}
              />
            </div>
            <div>
              <Input
                star
                type="select"
                list={giftProjects}
                label=" المشروع باهداء"
                disabled={isSmsBalanceLow}
                error={errors.GiftProjectId}
                input={register("GiftProjectId")}
              />
            </div>
            <div>
              <Input
                star
                type="select"
                label="التصنيف"
                list={categories}
                disabled={isSmsBalanceLow}
                input={register("classificationId")}
              />
            </div>
          </div>
        )}

        <div className="card p-4">
          <Input
            type="textarea"
            label="الرسالة"
            disabled={isSmsBalanceLow}
            error={errors.messageBody}
            input={register("messageBody")}
          />
          <div className="mt-3 flex flex-wrap justify-between gap-5">
            <label className="input-label text-gray-400">
              عدد الحروف {watch("messageBody")?.length}
            </label>
          </div>
        </div>

        <Button
          type="submit"
          title="أرسل رسالة"
          isLoading={isSubmitting}
          disabled={isSmsBalanceLow}
        />
      </form>
    </>
  );
};

export default Multiple;
